import i18n from '@src/common/lib/i18n'
const columnAll = function () {
  return [{
      label: i18n.t('realTimeAlarm.label.alarmName'),
      prop: 'alarmName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmType'),
      prop: 'alarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmLevel'),
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },

    {
      label: i18n.t('realTimeAlarm.label.videoUrl'),
      prop: 'videoUrl',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.reportPersonName'),
      prop: 'reportPersonName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmTime'),
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: '所属设备组',
      prop: 'deviceWorkGroupName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.ip'),
      prop: 'ip',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.desc'),
      prop: 'desc',
      formslot: true,
      span: 24
    },

  ]
}
//
//有毒有害气体
const columnGas = function () {
  return [{
      label: i18n.t('realTimeAlarm.label.alarmName'),
      prop: 'alarmName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmType'),
      prop: 'alarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmLevel'),
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmTime'),
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: '所属设备组',
      prop: 'deviceWorkGroupName',
      formslot: true,
      span: 24
    },
    {
      label: "监控点名称",
      prop: 'deviceName',
      formslot: true,
      span: 24
    },
    {
      label: "探测器名称",
      prop: 'parentDeviceName',
      formslot: true,
      span: 24
    },
    {
      label: "浓度值",
      prop: 'concentration',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.desc'),
      prop: 'desc',
      formslot: true,
      span: 24
    },

  ]
}
const columnPoison = function () {
  return [{
      label: i18n.t('realTimeAlarm.label.alarmName'),
      prop: 'alarmName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmType'),
      prop: 'alarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmLevel'),
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.videoUrl'),
      prop: 'videoUrl',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.reportPersonName'),
      prop: 'reportPersonName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmTime'),
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: '所属设备组',
      prop: 'deviceWorkGroupName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.ip'),
      prop: 'ip',
      formslot: true,
      span: 24
    },

  ]
}
const columnName = function () {
  return [{
      label: i18n.t('realTimeAlarm.label.alarmName'),
      prop: 'alarmName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmType'),
      prop: 'alarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmLevel'),
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },

    {
      label: i18n.t('realTimeAlarm.label.reportPersonName'),
      prop: 'reportPersonName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmTime'),
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: '所属设备组',
      prop: 'deviceWorkGroupName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.ip'),
      prop: 'ip',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.desc'),
      prop: 'desc',
      formslot: true,
      span: 24
    }
  ]
}
const columnVideo = function () {
  return [{
      label: i18n.t('realTimeAlarm.label.alarmName'),
      prop: 'alarmName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmType'),
      prop: 'alarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmLevel'),
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },

    {
      label: i18n.t('realTimeAlarm.label.videoUrl'),
      prop: 'videoUrl',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmTime'),
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: '所属设备组',
      prop: 'deviceWorkGroupName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.ip'),
      prop: 'ip',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.desc'),
      prop: 'desc',
      formslot: true,
      span: 24
    },
  ]
}
const columnNone = function () {
  return [{
      label: i18n.t('realTimeAlarm.label.alarmName'),
      prop: 'alarmName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmType'),
      prop: 'alarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmLevel'),
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    // {
    //   label: i18n.t('realTimeAlarm.label.realTimeVideo'),
    //   prop: 'realTimeVideo',
    //   formslot: true,
    //   span: 12
    // },
    // {
    //   label: i18n.t('realTimeAlarm.label.play'),
    //   prop: 'historyVideo',
    //   formslot: true,
    //   span: 12
    // },
    {
      label: i18n.t('realTimeAlarm.label.alarmTime'),
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: '所属设备组',
      prop: 'deviceWorkGroupName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.ip'),
      prop: 'ip',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.desc'),
      prop: 'desc',
      formslot: true,
      span: 24
    },

  ]
}
//停车场超时
const columnOverTime = function () {
  return [{
      label: '车辆号牌',
      prop: 'plateNo',
      formslot: true,
      span: 24
    },
    {
      label: '车辆分类',
      prop: 'personnelType',
      formslot: true,
      span: 24
    }, {
      label: '车主姓名',
      prop: 'personName',
      formslot: true,
      span: 24
    },
    {
      label: '联系电话',
      prop: 'personPhone',
      formslot: true,
      span: 24
    }, {
      label: '入场时间',
      prop: 'checkInTime',
      formslot: true,
      span: 24
    }, {
      label: '停车时长',
      prop: 'overSpeed',
      formslot: true,
      span: 24
    }, {
      label: '事件位置',
      prop: 'groupName',
      formslot: true,
      span: 24
    }, {
      label: '事件状态',
      prop: 'alarmStateLabel',
      formslot: true,
      span: 24
    },
  ]
}
const columnSpeed = function () {
  return [{
      label: i18n.t('realTimeAlarm.label.alarmName'),
      prop: 'alarmName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmType'),
      prop: 'alarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmLevel'),
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: '限速',
      prop: 'overSpeed',
      formslot: true,
      span: 24
    },
    {
      label: '上浮速度',
      prop: 'floatSpeed',
      formslot: true,
      span: 24
    },
    {
      label: '当前车速',
      prop: 'speed',
      formslot: true,
      span: 24
    },
    {
      label: '车牌',
      prop: 'plateNo',
      formslot: true,
      span: 24
    },
    {
      label: '车主姓名',
      prop: 'personName',
      formslot: true,
      span: 24
    },
    {
      label: '联系电话',
      prop: 'personPhone',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmTime'),
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: '所属设备组',
      prop: 'deviceWorkGroupName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.ip'),
      prop: 'ip',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.desc'),
      prop: 'desc',
      formslot: true,
      span: 24
    },
  ]
}
const columnHandle = function () {
  return [{
      label: i18n.t('realTimeAlarm.label.alarmName'),
      prop: 'alarmName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmType'),
      prop: 'alarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmLevel'),
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.videoUrl'),
      prop: 'videoUrl',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.reportPersonName'),
      prop: 'reportPersonName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmTime'),
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: '所属设备组',
      prop: 'deviceWorkGroupName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.desc'),
      prop: 'desc',
      formslot: true,
      span: 24
    },
  ]
}

const columnHelp = function () {
  return [{
      label: i18n.t('realTimeAlarm.label.alarmName'),
      prop: 'alarmName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmType'),
      prop: 'alarmTypeLabel',
      formslot: true,
      span: 24
    },
    {
      label: "故障类型",
      prop: 'alarmSubType',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmLevel'),
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmTime'),
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: '所属设备组',
      prop: 'deviceWorkGroupName',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.desc'),
      prop: 'desc',
      formslot: true,
      span: 24
    },
    {
      label: "一键求救设备",
      prop: 'deviceName',
      formslot: true,
      span: 24
    },
    {
      label: "设备位置",
      prop: 'groupName',
      formslot: true,
      span: 24
    },
  ]
}

const columnFire = function () {
  return [{
      label: i18n.t('realTimeAlarm.label.alarmLevel'),
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: "设备名称",
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: "设备类型",
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: "厂商型号",
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: "IP地址",
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: "标识号",
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: "所在位置",
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: "部件类型",
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: "部件地址",
      prop: 'alarmLevel',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.alarmTime'),
      prop: 'alarmTime',
      formslot: true,
      span: 24
    },
    {
      label: i18n.t('realTimeAlarm.label.desc'),
      prop: 'desc',
      formslot: true,
      span: 24
    }
  ]
}

export default {
  columnAll,
  columnName,
  columnVideo,
  columnNone,
  columnSpeed,
  columnHelp,
  columnHandle,
  columnPoison,
  columnFire, //消防告警
  columnGas, //有毒有害气体
  columnOverTime
}